import { createArcDiffusionScene } from './arc-diffusion-wireframe.js';
import { projector, renderCurves } from './research-wireframes.js';
import { ditGeometry } from './dit-wireframe.js';
import { ibltGeometry } from './iblt-wireframe.js';
import { homeClocks } from './masthead-motion.js';

// Decorative chapter illustrations, not literal model architectures.
// Geometry is built once; the existing renderer caches shared vertices.
function plane(desktop, placement, mobile = desktop) {
    let previousKey, previousPath;
    return (camera, motion, small, reduced) => {
        const key = `${camera}/${motion}/${small}/${reduced}`;
        if (key !== previousKey) {
            previousPath = renderCurves(small ? mobile : desktop, projector({ time: camera, ...placement(small) }), motion, reduced);
            previousKey = key;
        }
        return previousPath;
    };
}

// Keep projection work bounded on phones; identical intermediate frames reuse
// the previous path, including the resting side of the alternating masthead.
const sceneTime = (seconds, small) => Math.floor(seconds * (small ? 24 : 30)) / (small ? 24 : 30);

export { createEditPairScene as createEditingChapterScene } from './edit-pair-wireframe.js';

export function createDitChapterScene() {
    const draw = plane(ditGeometry().curves, small => ({
        phase: .8, x: small ? 380 : 625, y: small ? 252 : 242, scale: small ? .72 : .90, depth: .85,
    }), ditGeometry(true).curves);
    return { labels: [], draw(seconds, small, reduced = false) {
        const time = sceneTime(seconds, small);
        return { path: draw(time*.21, time*.48, small, reduced), labels: [] };
    }};
}

export function createOtherResearchChapterScene() {
    const arc = createArcDiffusionScene();
    const iblt = plane(ibltGeometry().curves, small => ({
        phase: .5, x: small ? 380 : 905, y: small ? 440 : 246, scale: small ? .66 : .59, depth: 1,
    }));
    return { labels: [], draw(seconds, small, reduced = false) {
        // Start with ARC immediately, then alternate with IBLT.
        const clocks = homeClocks(sceneTime(seconds, small) + 13);
        return {
            path: arc.draw(clocks.arcCamera / .42, small, reduced).path
                + iblt(clocks.training, clocks.training, small, reduced),
            labels: [],
        };
    }};
}

export { createDancingChapterScene, createWorkflowChapterScene } from './work-playful-scenes.js';
